import viewIndex from '@/views/layout'

export default [
    {
        name: 'layout',
        path: '',
        component: viewIndex,
        redirect: '/index', // 设置默认打开的页面
        children: [{
            name: 'index',
            path: '/index',
            component: () => import('@/views/index'),
            meta: {
                title: "概览"
            }
        }, {
            name: 'user_userlist',
            path: '/user_userlist',
            component: () => import('@/views/user/userlist'),
            meta: {
                title: "用户列表"
            }
        }, {
            name: 'user_userblacklist',
            path: '/user_userblacklist',
            component: () => import('@/views/user/userblacklist'),
            meta: {
                title: "黑名单列表"
            }
        }, {
            name: 'user_usercollectionlist',
            path: '/user_usercollectionlist',
            component: () => import('@/views/user/usercollectionlist'),
            meta: {
                title: "用户文章收藏列表"
            }
        }, {
            name: 'user_userfanslist',
            path: '/user_userfanslist',
            component: () => import('@/views/user/userfanslist'),
            meta: {
                title: "关注粉丝列表"
            }
        }, {
            name: 'user_userfriendlist',
            path: '/user_userfriendlist',
            component: () => import('@/views/user/userfriendlist'),
            meta: {
                title: "好友列表"
            }
        }, {
            name: 'user_userliuyanlist',
            path: '/user_userliuyanlist',
            component: () => import('@/views/user/userliuyanlist'),
            meta: {
                title: "留言列表"
            }
        }, {
            name: 'user_uservisitorlist',
            path: '/user_uservisitorlist',
            component: () => import('@/views/user/uservisitorlist'),
            meta: {
                title: "访客列表"
            }
        }, {
            name: 'user_friendrequest',
            path: '/user_friendrequest',
            component: () => import('@/views/user/friendrequest'),
            meta: {
                title: "好友申请列表"
            }
        }, {
            name: 'user_thirdloginlist',
            path: '/user_thirdloginlist',
            component: () => import('@/views/user/thirdloginlist'),
            meta: {
                title: "第三方登录账号列表"
            }
        }, {
            name: 'user_userdownloadlist',
            path: '/user_userdownloadlist',
            component: () => import('@/views/user/userdownloadlist'),
            meta: {
                title: "用户下载记录"
            }
        }, {
            name: 'user_userintegrallog',
            path: '/user_userintegrallog',
            component: () => import('@/views/user/userintegrallog'),
            meta: {
                title: "积分记录列表"
            }
        }, {
            name: 'user_usermoneylog',
            path: '/user_usermoneylog',
            component: () => import('@/views/user/usermoneylog'),
            meta: {
                title: "金额变化记录"
            }
        }, {
            name: 'user_useroperate',
            path: '/user_useroperate',
            component: () => import('@/views/user/useroperate'),
            meta: {
                title: "用户操作日志"
            }
        }, {
            name: 'user_usermessagelist',
            path: '/user_usermessagelist',
            component: () => import('@/views/user/usermessagelist'),
            meta: {
                title: "用户消息列表"
            }
        }, {
            name: 'user_usermessagereplylist',
            path: '/user_usermessagereplylist',
            component: () => import('@/views/user/usermessagereplylist'),
            meta: {
                title: "用户消息回复列表"
            }
        }, {
            name: 'user_sysmessagelist',
            path: '/user_sysmessagelist',
            component: () => import('@/views/user/sysmessagelist'),
            meta: {
                title: "系统消息列表"
            }
        }, {
            name: 'user_sysmessagereadlist',
            path: '/user_sysmessagereadlist',
            component: () => import('@/views/user/sysmessagereadlist'),
            meta: {
                title: "系统消息已读列表"
            }
        }, {
            name: 'art_artlist',
            path: '/art_artlist',
            component: () => import('@/views/art/artlist'),
            meta: {
                title: "文章列表"
            }
        }, {
            name: 'art_artcommentlist',
            path: '/art_artcommentlist',
            component: () => import('@/views/art/artcommentlist'),
            meta: {
                title: "文章评论列表"
            }
        }, {
            name: 'art_artdownloadlist',
            path: '/art_artdownloadlist',
            component: () => import('@/views/art/artdownloadlist'),
            meta: {
                title: "文章下载地址列表"
            }
        }, {
            name: 'art_artpiclist',
            path: '/art_artpiclist',
            component: () => import('@/views/art/artpiclist'),
            meta: {
                title: "文章图片管理"
            }
        }, {
            name: 'art_tagslist',
            path: '/art_tagslist',
            component: () => import('@/views/art/tagslist'),
            meta: {
                title: "Tags标签库"
            }
        }, {
            name: 'art_arttypelist',
            path: '/art_arttypelist',
            component: () => import('@/views/art/arttypelist'),
            meta: {
                title: "文章类别列表"
            }
        }]
    },
    {
        name: "login",
        path: "/login",
        component: () => import('@/views/login'),
        meta: {
            title: '网站管理中心_管理员登录'
        }
    },
    {
        path: '*',
        redirect: { name: 'index' }
    }
]